import React from "react";
import Banner from "../../../components/Banner";
import AccountSettings from "../../../components/AccountSettings";
import Header from "../../../components/Header";
import { PAYMENTS } from "../../../constants/settingsStrings.js";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import Topbar from "../../../components/Topbar";
import Bottombar from "../../../components/Bottombar";
import { Link } from "react-router-dom";

function PaymentContinue() {
  const text = "";
  return (
    <div className="dark:bg-white min-h-screen overflow-hidden dark:text-black">
      <div className="sm:hidden">
        <Topbar />
      </div>
      <div className="hidden md:block">
        <Header />
      </div>
      <div className="sm:hidden flex items-center justify-between px-4 mt-6 mb-4">
        <Link to="/settings/paymentmethod">
          <ArrowLeftIcon color="#545454" className="w-5 h-5 hover:bg-gray-100 dark:hover:bg-gray-800 rounded p-1 transition-colors" />
        </Link>
        <h3 className="dark:text-black font-semibold text-lg">Payment Method</h3>
        <div className="w-5"></div> {/* Spacer for centering */}
      </div>

      <div className="mt-6 sm:hidden px-4">
        <div className="flex justify-between items-center">
          <div className="flex-1 text-center">
            <div className="bg-[#42BA96] rounded-full h-4 w-4 mx-auto flex items-center justify-center">
              <span className="text-xs font-bold text-white">✓</span>
            </div>
            <div className="mt-2 font-medium text-sm text-gray-600 dark:text-gray-700">
              Details
            </div>
          </div>
          <div className="flex-1 border-t border-gray-300 mt-[-10px]"></div>
          <div className="flex-1 text-center">
            <div className="bg-[#42BA96] rounded-full h-4 w-4 mx-auto flex items-center justify-center">
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
            <div className="mt-2 font-medium text-sm text-gray-600 dark:text-gray-700">
              Payment
            </div>
          </div>
          <div className="flex-1 border-t border-gray-300 mt-[-10px]"></div>
          <div className="flex-1 text-center">
            <div className="bg-gray-300 rounded-full h-4 w-4 mx-auto flex items-center justify-center">
              <div className="w-2 h-2 bg-gray-500 rounded-full"></div>
            </div>
            <div className="mt-2 font-medium text-sm text-gray-400 dark:text-gray-500">
              Confirm
            </div>
          </div>
        </div>
      </div>
      <div className="border-2 mx-4 max-w-sm h-28 rounded-3xl mt-6 bg-banner2 relative sm:hidden overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-between p-5">
          <div>
            <h3 className="text-white font-extrabold text-lg font-sans leading-tight">
              GO{" "}
              <span className="bg-[#0049F5] px-2 py-1 text-xs text-white rounded-full inline-block">
                PRO
              </span>
              <br />
              PREMIUM!
            </h3>
          </div>
          <div className="flex-shrink-0">
            <img
              src="https://uibfs.s3.eu-north-1.amazonaws.com/Saly-41.png"
              className="w-20 h-24 object-contain"
              alt="Premium illustration"
            />
          </div>
        </div>
      </div>
      <div className="flex ">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>

        <div className="w-[925px]   sm:w-[64vw] mt-2 h-[500px] rounded-[25px] sm:shadow-xl  sm:mx-10  ">
          <div className=" hidden md:block ">
           
            <Banner />
          </div>
       <div className="md:block hidden">
       <div className="flex flex-col md:flex-row justify-center items-center mt-6 space-y-4 md:space-y-0 md:space-x-16 relative">
      {/* Step 1 */}
      <div className="flex flex-col items-center">
        <div className="bg-[#42BA96] text-white rounded-full h-8 w-8 flex items-center justify-center">
          ✓
        </div>
        <div className="mt-2 text-gray-600 text-center">Details</div>
      </div>

      {/* Connecting Line 1 */}
      {/* <div className="absolute left-[12.5%] top-4 md:left-[calc(20%-8rem)] md:w-1/3 h-1 bg-[#42BA96]"></div> */}

      {/* Step 2 */}
      <div className="flex flex-col items-center">
        <div className="bg-[#42BA96] text-white rounded-full h-8 w-8 flex items-center justify-center">
        
        </div>
        <div className="mt-2 text-gray-600 text-center">Payment</div>
      </div>

      {/* Connecting Line 2 */}
      {/* <div className="absolute left-[calc(12.5%+8rem)] top-4 md:left-[calc(50%+8rem)] md:w-1/3 h-1 bg-[#42BA96]"></div> */}

      {/* Step 3 */}
      <div className="flex flex-col items-center">
        <div className="bg-[#42BA96] text-white rounded-full h-8 w-8 flex items-center justify-center">
          
        </div>
        <div className="mt-2 text-gray-600 text-center">Confirm</div>
      </div>
    </div>
       </div>

          <img
            src={require("../../../assets/img/visa.png")}
            alt=""
            className="h-[48px] w-[80px]  md:hidden ml-10  "
          />
          <div className=" sm:flex justify-between sm:mt-[10px] sm:mr-[80px] m-7   sm:m-0">
            <div className="  ">
              <div className="font-semibold m-4 sm:text-[10px] text-[#202124] dark:text-black font-sans flex sm:space-x-[100px]  space-x-[160px]  text-[14px] ">
                <div>
                  {" "}
                  <p>Monthly </p>
                  <p>Taxes</p>
                </div>
                <div className="ml-[70px]">
                  <p>300,000 UGX</p>
                  <p>10,000 UGX</p>
                </div>
              </div>
              <div className="border-[1px] sm:w-[180px] w-[300px] mb-2 ml-4"></div>
              <div className=" font-semibold sm:text-[10px] flex mb-4  sm:mb-0 ml-4 sm:space-x-[100px] space-x-[160px] dark:text-black text-[14px]">
                <p>Subtotal</p>
                <p>310,000 UGXl</p>
              </div>
              <div className="border-[1px] sm:w-[180px] w-[300px] sm:mb-2 mb-6 ml-4"></div>
            </div>
            <div className="sm:space-y-2 space-y-3 sm:mb-2">
              <div className="border-[2px] border-[#BDBDBD] w-[328px] h-[40px]  grid place-content-center sm:h[30px] rounded-[4px] ">
                <input
                  type="text"
                  placeholder="Name"
                  className=" px-2 text-[#212529] tex-[10px] outline-none dark:text-black bg-white  dark:bg-white w-[310px] placeholder:px-2 placeholder:font-bold placeholder:text-black"
                />
              </div>
              <div className="border-[2px] border-[#BDBDBD] w-[328px] h-[40px] sm:h[30px] grid place-content-center rounded-[4px] ">
                <input
                  type="text"
                  placeholder="Country"
                  className=" px-2 text-[#212529] tex-[10px] outline-none dark:text-black bg-white  dark:bg-white w-[310px]  placeholder:px-2 placeholder:font-bold placeholder:text-black "
                />
              </div>
              <div className="border-[2px] border-[#BDBDBD] w-[328px] h-[40px] sm:h[30px]  grid place-content-center rounded-[4px] ">
              
                <input
                  type="text"
                  placeholder="Zip code"
                  className=" px-2 text-[#212529] tex-[3px] outline-none place-items-center dark:text-black bg-white dark:bg-white w-[310px] placeholder:px-2 placeholder:font-bold placeholder:text-black"
                />
              </div>
            </div>
          </div>
          <div className="flex ">
          <div className="border md:block hidden rounded-[15.875px] w-[70px] h-[48px] items-center  justify-center lg:flex border-[#D9D9D9] sm:ml-10 relative bottom-[0px]">
              <img
                src={require("../../../assets/img/visa.png")}
                alt=""
                className="h-10 w-10   "
              />
            </div>

            <Link to="/settings/paymentnextstep">
              <button className="bg-[#0049F5]  text-white w-[315px] sm:h-[34.68px] h-[54.68px] rounded-[27.34px]  ml-7 sm:m-0 sm:ml-[250px]">
                Continue
              </button>
            </Link>
          </div>
        </div>
      </div>
      <h3 className=" md:block hidden dark:text-black absolute text-[12px] text-[#878787] font-[900] mt-9  sm:left-[50%]  bottom-[70px] left-[40%]">
          Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'} />
    </div>
  );
}

export default PaymentContinue;
